<div *ngIf="handsetService.isXs; else desktop" >
  <app-add-liability-scan-mobile
    [files]="files"
    [error]="error"
    [uploading]="uploading"
    [filesAdded]="filesAdded"
    [remove]="remove"
    [submit]="uploadDocumentsForAutomaticReading"
    [checkPermissions]="checkPermissions"
    [disabled]="disabled"
  ></app-add-liability-scan-mobile>
</div>

<ng-template #desktop>
  <app-add-liability-scan-desktop
    [files]="files"
    [error]="error"
    [uploading]="uploading"
    [addDroppedFile]="addDroppedFile"
    [filesAdded]="filesAdded"
    [showDropArea]="showDropArea"
    [hideDropArea]="hideDropArea"
    [remove]="remove"
    [submit]="uploadDocumentsForAutomaticReading"
    [disabled]="disabled"
  ></app-add-liability-scan-desktop>
</ng-template>
